import { Button, Label } from "@xola/ui-kit";
import clsx from "clsx";
import React, { useState } from "react";

const selectorCurrent = "bg-blue-lighter hover:bg-blue-lighter active:bg-blue-lighter active:text-primary";

export type SelectorItem<T extends string | number> = {
    display: string;
    value: T;
};

interface SelectorProps<T extends string | number> {
    title: string;
    className?: string;
    defaultValue: SelectorItem<T>["value"];
    list: Array<SelectorItem<T>>;
    onSetValue: (value: SelectorItem<T>["value"]) => void;
}

export const Selector = <T extends string | number>({
    title,
    className,
    defaultValue,
    list,
    onSetValue,
}: SelectorProps<T>) => {
    const [currentValue, setCurrentValue] = useState(defaultValue ?? "");

    const handleClick = (value: any) => {
        return () => {
            setCurrentValue(value);
            if (onSetValue) {
                onSetValue(value);
            }
        };
    };

    return (
        <div className={className}>
            <Label>{title}</Label>
            <div className="flex justify-between gap-2 sm:gap-4">
                {list.map((item) => (
                    <Button
                        key={`fbsel-${item.value}`}
                        variant="outline"
                        color={item.value === currentValue ? "primary" : "secondary"}
                        className={clsx(
                            "flex-1 py-4 px-1 text-md focus:ring-0",
                            item.value === currentValue ? selectorCurrent : "",
                        )}
                        onClick={handleClick(item.value)}
                    >
                        {item.display}
                    </Button>
                ))}
            </div>
        </div>
    );
};
